import { Feature } from "components/feature";
import * as React from "react";
import * as ReportConstants from "../constants";
import { CustomReports } from "./custom-reports";
import { FranchiseRoyalties } from "./franchise-royalties";
import { ReferralSource } from "./referral-source";
import { Referrals } from "./referrals";
import { ClientPlacementRevenue } from "./revenue";
import { StageConversion } from "./stage-conversion";
import { Summary } from "./summary";

interface Props {
    reportName: ReportConstants.ReportNames;
}

export const ReportsShow: React.FC<Props> = props => {
    const reportName = props.reportName;

    if (reportName === "summary") {
        return <Summary />;
    }

    if (reportName === "revenue") {
        return <ClientPlacementRevenue />;
    }

    if (reportName === "inbound-referrals" || reportName === "referrals") {
        return <Referrals />;
    }

    if (reportName === "referral-source") {
        return (
            <Feature name="referralSourceReport">
                <ReferralSource />
            </Feature>
        );
    }

    if (reportName === "custom") {
        return <CustomReports />;
    }

    if (reportName === "stage-conversion") {
        return (
            <Feature name="stageConversion">
                <StageConversion />
            </Feature>
        );
    }

    if (reportName === "franchise-royalties") {
        return (
            <Feature name="franchiseManagement">
                <FranchiseRoyalties />
            </Feature>
        );
    }

    return <h2>Sorry, no report found</h2>;
};
